import React from "react";

const YouTubeEmbed = ({ value }) => {
  const {
    url,
    title,
    aspectRatio = "16:9",
    autoplay = false,
    controls = true,
  } = value;

  const getVideoId = (url) => {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  const videoId = getVideoId(url);
  if (!videoId) return null;

  const embedUrl = `https://www.youtube.com/embed/${videoId}?${
    autoplay ? "autoplay=1&" : ""
  }${!controls ? "controls=0&" : ""}rel=0`;

  return (
    <div className="my-8">
      <div
        className="relative overflow-hidden rounded-lg shadow-lg"
        style={{ paddingBottom: aspectRatio === "16:9" ? "56.25%" : "75%" }}
      >
        <iframe
          src={embedUrl}
          title={title || "YouTube video"}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="absolute top-0 left-0 w-full h-full"
        />
      </div>
      {title && (
        <p className="mt-2 text-sm text-gray-600 italic text-center">{title}</p>
      )}
    </div>
  );
};

export default YouTubeEmbed;
